import React, { useEffect } from 'react';

import TitleUndescore from 'modules/shared/TitleUndescore';
import { Checkbox, Input, MaskInput, Select } from 'modules/shared/Forms';

import classNames from 'classnames';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Plus from 'mdi-react/PlusIcon';
import Minus from 'mdi-react/CloseIcon';
import { FieldArray, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SettingsSMSCard.module.scss';
import { getMessageCauseRequest, postSendTestMessageRequest } from '../../../containers/BranchEditing/actions';
import { branchSelector } from '../../../containers/BranchEditing/selectors';

type Props = {
  onChange: (e: React.ChangeEvent<any>) => void;
  values: any;
};

const SettingsSMSCard: React.FC<Props> = ({ onChange, values }) => {
  const dispatch = useDispatch();
  const formik = useFormikContext();
  const { setFieldValue } = formik;

  const { causes } = useSelector(branchSelector);

  useEffect(() => {
    dispatch(getMessageCauseRequest());
  }, []);

  const sendTestSms = (number: string, branchId: number) => {
    const phoneNumber = number.replace(/\D/g, '');
    dispatch(postSendTestMessageRequest({ phoneNumber, branchId }));
  };

  const { messageTemplates } = values;

  return (
    <div className="my-5">
      <TitleUndescore title="Сервіс СМС" />
      <div className="pl-4">
        <div className="d-flex flex-row">
          <Row>
            <Col>Задіяти СМС сервіс:</Col>
            <Col>
              <Checkbox
                name="smsServiceSetting.isWork"
                label=""
                className={styles.checkbox}
                onChange={(e: React.ChangeEvent<any>) => {
                  onChange(e);
                  setFieldValue('sendPhoneVerification', false);
                }}
              />
            </Col>
          </Row>
          {values?.smsServiceSetting?.status && (
            <span className={styles.status}>({values?.smsServiceSetting?.status})</span>
          )}
        </div>
        <Row>
          <Col>Верифікація номера телефону при реєстрації рейса через СМС:</Col>
          <Col style={{ marginLeft: '-40rem' }}>
            <Checkbox
              name="sendPhoneVerification"
              label=""
              className={styles.checkbox}
              onChange={onChange}
              disabled={values?.smsServiceSetting?.isWork === false}
            />
          </Col>
        </Row>
        <MaskInput
          name="phone"
          onLine
          label="Відправити тестове повідомлення"
          placeholder="38 (0XX) XXX-XX-XX"
          onChange={onChange}
          className={styles.phone}
          noGrowth
        >
          <Button
            className={styles.sendBtn}
            onClick={() => sendTestSms(values?.phone, values?.smsServiceSetting?.branchId)}
          >
            Надіслати
          </Button>
        </MaskInput>
        <TitleUndescore title="Сповіщення водія і експедитора" className="small" />
        <FieldArray
          name="messageTemplates.driverTemplates"
          render={(arrayHelpers) => {
            const addHandler = () =>
              arrayHelpers.push({ driverSMStype: '', messageText: '', isEnabled: false, messageRecipient: 0 });
            const removeHandler = (index: number) => arrayHelpers.remove(index);
            return (
              <div className="d-flex flex-row w-100">
                <div className="col-4 pl-4 ml-1 mr-2 mb-4 position-relative">
                  <Button
                    variant="success"
                    className={classNames(styles.plus_btn, 'rounded-circle')}
                    onClick={addHandler}
                  >
                    <Plus size="14" />
                  </Button>
                  <Form.Label>
                    <div className="d-flex flex-column">
                      <span style={{ marginLeft: '30px' }} className="ml-2">
                        Додати сповіщення:
                      </span>
                      <span className="ml-2 mt-2 text-secondary">[auto] - держномер автомобіля;</span>
                    </div>
                  </Form.Label>
                </div>
                <div className="d-flex flex-column">
                  {messageTemplates?.driverTemplates?.map((v: any, index: number) => (
                    <div className="d-flex flex-column position-relative mb-2" key={index}>
                      <div className={classNames(styles.wrapper, 'd-flex flex-column mb-2')}>
                        <div className={classNames(styles.pr27, 'd-flex flex-row mb-2')}>
                          <Select
                            className={styles.smsSelect}
                            label=""
                            name={`messageTemplates.driverTemplates[${index}].causeSendingMessageId`}
                            onChange={onChange}
                          >
                            {
                              // @ts-ignore
                              causes?.map((cause: any) => (
                                <option value={Number(cause.id)}>{cause.description}</option>
                              ))
                            }
                          </Select>
                          <Button
                            variant="danger"
                            className={classNames(styles.minus_btn_SMS, 'rounded-circle')}
                            onClick={() => removeHandler(index)}
                          >
                            <Minus size={14} />
                          </Button>
                          <Checkbox
                            name={`messageTemplates.driverTemplates[${index}].isEnabled`}
                            className={styles.checkboxSett}
                            label="Увімкнути правило"
                            onChange={onChange}
                          />
                        </div>
                        <Input
                          className={styles.textArea}
                          placeholder="Текст смс-повідомлення..."
                          onLine
                          name={`messageTemplates.driverTemplates[${index}].messageText`}
                          onChange={onChange}
                          maxLength={70}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }}
        />
        <TitleUndescore title="Сповіщення менеджера" className="small" />
        <FieldArray
          name="messageTemplates.managerTemplates"
          render={(arrayHelpers) => {
            const addHandler = () =>
              arrayHelpers.push({
                managerSMStype: '',
                messageText: '',
                isEnabled: false,
                messageRecipient: 1,
              });
            const removeHandler = (index: number) => arrayHelpers.remove(index);

            return (
              <div className="d-flex flex-row w-100">
                <div className="col-4 pl-4 ml-1 mr-2 mb-4 position-relative">
                  <Button
                    variant="success"
                    className={classNames(styles.plus_btn, 'rounded-circle')}
                    onClick={addHandler}
                  >
                    <Plus size="14" />
                  </Button>
                  <Form.Label>
                    <div className="d-flex flex-column">
                      <span className="ml-2" style={{ marginLeft: '30px' }}>
                        Додати сповіщення:
                      </span>
                      <span className="ml-2 mt-2 d-flex flex-column text-secondary">
                        <span>[order] - номер замовлення;</span>
                        <span>[book] - час бронювання;</span>
                        <span>[status] - статус бронювання.</span>
                      </span>
                    </div>
                  </Form.Label>
                </div>
                <div />
                <div className="d-flex flex-column">
                  {messageTemplates?.managerTemplates?.map((v: any, index: number) => (
                    <div className="d-flex flex-column position-relative mb-2" key={index}>
                      <div className={classNames(styles.wrapper, 'd-flex flex-column mb-2')}>
                        <div className={classNames(styles.pr27, 'd-flex flex-row mb-2')}>
                          <Select
                            className={styles.smsSelect}
                            label=""
                            name={`messageTemplates.managerTemplates[${index}].causeSendingMessageId`}
                            onChange={onChange} // @ts-ignore
                          >
                            {
                              // @ts-ignore
                              causes?.map((cause: any) => (
                                <option value={Number(cause.id)}>{cause.description}</option>
                              ))
                            }
                          </Select>
                          <Button
                            variant="danger"
                            className={classNames(styles.minus_btn_SMS, 'rounded-circle')}
                            onClick={() => removeHandler(index)}
                          >
                            <Minus size={14} />
                          </Button>
                          <Checkbox
                            name={`messageTemplates.managerTemplates[${index}].isEnabled`}
                            className={styles.checkboxSett}
                            label="Увімкнути правило"
                            onChange={onChange}
                          />
                        </div>
                        <Input
                          onLine
                          placeholder="Текст смс-повідомлення..."
                          className={styles.textArea}
                          name={`messageTemplates.managerTemplates[${index}].messageText`}
                          onChange={onChange}
                          maxLength={70}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }}
        />
        <TitleUndescore title="Сповіщення клієнта" className="small" />
        <FieldArray
          name="messageTemplates.clientTemplates"
          render={(arrayHelpers) => {
            const addHandler = () =>
              arrayHelpers.push({
                clientSMStype: '',
                messageText: '',
                isEnabled: false,
                messageRecipient: 1,
              });
            const removeHandler = (index: number) => arrayHelpers.remove(index);

            return (
              <div className="d-flex flex-row w-100">
                <div className="col-4 pl-4 ml-1 mr-2 mb-4 position-relative">
                  <Button
                    variant="success"
                    className={classNames(styles.plus_btn, 'rounded-circle')}
                    onClick={addHandler}
                  >
                    <Plus size="14" />
                  </Button>
                  <Form.Label>
                    <div className="d-flex flex-column">
                      <span className="ml-2" style={{ marginLeft: '30px' }}>
                        Додати сповіщення:
                      </span>
                      <span className="ml-2 mt-2 d-flex flex-column text-secondary">
                        <span>[order] - номер замовлення;</span>
                        <span>[book] - час бронювання;</span>
                        <span>[status] - статус бронювання.</span>
                      </span>
                    </div>
                  </Form.Label>
                </div>
                <div />
                <div className="d-flex flex-column">
                  {messageTemplates?.clientTemplates?.map((v: any, index: number) => (
                    <div className="d-flex flex-column position-relative mb-2" key={index}>
                      <div className={classNames(styles.wrapper, 'd-flex flex-column mb-2')}>
                        <div className={classNames(styles.pr27, 'd-flex flex-row mb-2')}>
                          <Select
                            className={styles.smsSelect}
                            label=""
                            name={`messageTemplates.clientTemplates[${index}].causeSendingMessageId`}
                            onChange={onChange} // @ts-ignore
                          >
                            {
                              // @ts-ignore
                              causes?.map((cause: any) => (
                                <option value={Number(cause.id)}>{cause.description}</option>
                              ))
                            }
                          </Select>
                          <Button
                            variant="danger"
                            className={classNames(styles.minus_btn_SMS, 'rounded-circle')}
                            onClick={() => removeHandler(index)}
                          >
                            <Minus size={14} />
                          </Button>
                          <Checkbox
                            name={`messageTemplates.clientTemplates[${index}].isEnabled`}
                            className={styles.checkboxSett}
                            label="Увімкнути правило"
                            onChange={onChange}
                          />
                        </div>
                        <Input
                          onLine
                          placeholder="Текст смс-повідомлення..."
                          className={styles.textArea}
                          name={`messageTemplates.clientTemplates[${index}].messageText`}
                          onChange={onChange}
                          maxLength={70}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }}
        />
        <TitleUndescore title="Сповіщення завсклада" className="small" />
        <div className="d-flex flex-row w-100">
          <div className="col-4 pl-4 ml-1 mr-2 mb-4 position-relative">
            <Form.Label>
              <div className="d-flex flex-column">
                <span className="ml-2">Сповіщення:</span>
                <span className="ml-2 mt-2 d-flex flex-column text-secondary">
                  <span>[book] - час бронювання</span>
                </span>
              </div>
            </Form.Label>
          </div>
          <div />
          <div className="d-flex flex-column">
            <div className="d-flex flex-column position-relative mb-2">
              <div className={classNames(styles.wrapper, 'd-flex flex-column mb-2')}>
                <div className={classNames(styles.pr27, 'd-flex flex-row mb-2')}>
                  <Select
                    className={styles.smsSelect}
                    label=""
                    name="messageTemplates.directorTemplate.causeSendingMessageId"
                    onChange={onChange} // @ts-ignore
                  >
                    <option value={10}>Бронь зареєстрована, необхідно розглянути</option>
                  </Select>
                  <Checkbox
                    name="messageTemplates.directorTemplate.isEnabled"
                    className={styles.checkboxSett}
                    label="Увімкнути правило"
                    onChange={onChange}
                  />
                </div>
                <Input
                  onLine
                  placeholder="Текст смс-повідомлення..."
                  className={styles.textArea}
                  name="messageTemplates.directorTemplate.messageText"
                  onChange={onChange}
                  maxLength={70}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSMSCard;
